import { render, staticRenderFns } from "./CompareETF.vue?vue&type=template&id=b91a76b2&scoped=true&"
import script from "./CompareETF.vue?vue&type=script&lang=js&"
export * from "./CompareETF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91a76b2",
  null
  
)

export default component.exports